
export class ApiError extends Error {
  public responseData: any;

  constructor(message: string, responseData: any) {
    super(message);
    this.responseData = responseData;
  }
}